import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { MatRippleModule } from '@angular/material/core';
import { NbEvaIconsModule } from '@nebular/eva-icons';
import { NbSecurityModule } from '@nebular/security';
import {
  NbActionsModule,
  NbButtonModule,
  NbCardModule,
  NbContextMenuModule,
  NbIconModule,
  NbJSThemeOptions,
  NbLayoutDirection,
  NbLayoutModule,
  NbMediaBreakpoint,
  NbMenuModule,
  NbSearchModule,
  NbSelectModule,
  NbSidebarModule,
  NbThemeModule,
  NbThemeOptions,
  NbUserModule,
} from '@nebular/theme';

import { NbIonFaIconsModule } from '@res/ngg-core';
import {
  CallActionCardComponent,
  FooterComponent,
  HeaderComponent,
  LayoutDirectionSwitcherComponent,
  SearchInputComponent,
  ThemeSettingsComponent,
  TinyMCEComponent,
  ToggleSettingsButtonComponent,
} from './components';
import {
  OneColumnLayoutComponent,
  SampleLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
} from './layouts';
import { NgxCapitalizePipe as CapitalizePipe, NumberWithCommasPipe, PluralPipe, RoundPipe, TimingPipe } from './pipes';
import { MATERIAL_DARK_THEME } from './styles/material/theme.material-dark';
import { MATERIAL_LIGHT_THEME } from './styles/material/theme.material-light';
import { CORPORATE_THEME } from './styles/theme.corporate';
import { COSMIC_THEME } from './styles/theme.cosmic';
import { DARK_THEME } from './styles/theme.dark';
import { DEFAULT_THEME } from './styles/theme.default';
import { Theme, ThemeDefaultParams } from 'ag-grid-community';

export const ALL_THEMES: Array<NbJSThemeOptions & { agGridTheme: Theme<ThemeDefaultParams> }> = [
  DEFAULT_THEME,
  COSMIC_THEME,
  CORPORATE_THEME,
  DARK_THEME,
  MATERIAL_LIGHT_THEME,
  MATERIAL_DARK_THEME,
];

const NB_MODULES = [
  NbLayoutModule,
  NbMenuModule,
  NbUserModule,
  NbActionsModule,
  NbSearchModule,
  NbSidebarModule,
  NbContextMenuModule,
  NbSecurityModule,
  NbButtonModule,
  NbSelectModule,
  NbIconModule,
  NbEvaIconsModule,
  NbIonFaIconsModule,
  NbCardModule,
];
const COMPONENTS = [
  HeaderComponent,
  FooterComponent,
  SearchInputComponent,
  TinyMCEComponent,
  OneColumnLayoutComponent,
  ThreeColumnsLayoutComponent,
  TwoColumnsLayoutComponent,
  CallActionCardComponent,
  ToggleSettingsButtonComponent,
  LayoutDirectionSwitcherComponent,
  SampleLayoutComponent,
  ThemeSettingsComponent,
];
const PIPES = [CapitalizePipe, PluralPipe, RoundPipe, TimingPipe, NumberWithCommasPipe];

@NgModule({
  imports: [CommonModule, MatRippleModule, ...NB_MODULES, ...COMPONENTS, ...PIPES],
  exports: [CommonModule, MatRippleModule, ...PIPES, ...COMPONENTS],
  // declarations: [...COMPONENTS, ...PIPES],
})
export class ThemeModule {
  static forRoot(
    themeSettings: {
      nbThemeOptions: NbThemeOptions;
      nbJSThemes: NbJSThemeOptions[];
      nbMediaBreakpoints?: NbMediaBreakpoint[];
      layoutDirection?: NbLayoutDirection;
    } = { nbJSThemes: ALL_THEMES, nbThemeOptions: { name: 'default' } },
  ): ModuleWithProviders<ThemeModule> {
    return {
      ngModule: ThemeModule,
      providers: NbThemeModule.forRoot(
        themeSettings.nbThemeOptions,
        themeSettings.nbJSThemes,
        themeSettings.nbMediaBreakpoints,
        themeSettings.layoutDirection,
      ).providers,
    };
  }
}

// @Component({
//   template: ``,
//   standalone: true,
//   imports: [ThemeModule],
// })
// export class ThemeComponent {
//   static forRoot(defaulttheme: string = 'default'): ModuleWithProviders<ThemeModule> {
//     return {
//       ngModule: ThemeModule,
//       providers: NbThemeModule.forRoot(
//         {
//           name: defaulttheme,
//         },
//         [DEFAULT_THEME, COSMIC_THEME, CORPORATE_THEME, DARK_THEME, MATERIAL_LIGHT_THEME, MATERIAL_DARK_THEME]
//       ).providers,
//     };
//   }
// }
